export enum Byte {
  KB = 1024,
  MB = 1048576,
  GB = 1073741824,
}

export enum Extension {
  PNG = 'png',
  JPEG = 'jpeg',
  JPG = 'jpg',
  PDF = 'pdf',
  MP3 = 'mp3',
  MP4 = 'mp4',
  HWP = 'hwp',
  DOC = 'doc',
  DOCX = 'docx',
  XLS = 'xls',
  XLSX = 'xlsx',
  PPT = 'ppt',
  PPTX = 'pptx',
  ALL = 'all',
}

export interface LimitSet {
  extention: Extension;
  size: number;
}

/**
 * 확장자 별로 제한 사이즈를 벗어났는지 확인하는 함수
 * @param file 사이즈를 체크할 파일
 * @param limitSet 확장자, 사이즈로 구성된 크기를 체크할 셋
 */
export const isOverFileLimit = (file: File, limitSet: LimitSet[]): boolean => {
  const { name, size } = file;

  const extention = getExtention(name);

  return limitSet.some((limit) => {
    if (limit.extention == 'all') {
      return size > limit.size;
    }
    if (limit.extention.toLocaleLowerCase() === extention.toLocaleLowerCase()) {
      return size > limit.size;
    }
  });
};
/**
 * 파일의 확장자를 얻어오는 함수
 * @param fileName 확장자 포함된 파일이름
 */
export const getExtention = (fileName: string) => {
  return fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length).toLocaleLowerCase();
};

/**
 * 파일의 확장자를 얻어오는 함수
 * @param fileName 확장자 포함된 파일이름
 */
export const isFileViewer = (fileName: string) => {
  const ext = fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length).toLocaleLowerCase();

  const possible = ['jpg', 'jpeg', 'png', 'pdf'];
  return possible.indexOf(ext) > -1;
};

export const isImageFile = (filename: string) => {
  const possible = ['jpg', 'jpeg', 'png'];
  return possible.indexOf(getExtention(filename)) > -1;
};